// src/api/api.js

import axios from "axios";
//import API_BASE_URL from "../../config";

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5113/api';
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Adds token + logs request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    // Skip adding token for /auth/login
    if (token && !config.url.includes("/auth/login")) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    console.log("%c[API REQUEST]", "color: blue", {
      method: config.method?.toUpperCase(),
      url: config.url,
      data: config.data,
      headers: config.headers,
    });

    return config;
  },
  (error) => {
    console.error("[API REQUEST ERROR]", error);
    return Promise.reject(error);
  }
);

// Response Interceptor: Logs response or error
axiosInstance.interceptors.response.use(
  (response) => {
    console.log("%c[API RESPONSE]", "color: green", {
      url: response.config.url,
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error) => {
    if (error.response) {
      console.error("[API RESPONSE ERROR]", {
        url: error.config.url,
        status: error.response.status,
        data: error.response.data,
      });
    } else {
      console.error("[NETWORK ERROR]", error.message);
    }
    return Promise.reject(error);
  }
);

// Utility: Unified Error Handler
const handleError = (error) => {
  console.error("[API ERROR]", error);
  throw error; // rethrow so callers can catch
};

// Generic GET all
export const apiGet = async (endpoint) => {
  try {
    const response = await axiosInstance.get(endpoint);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Generic GET by ID
export const apiGetById = async (endpoint, id) => {
  try {
    const response = await axiosInstance.get(`${endpoint}/${id}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Generic POST
export const apiPost = async (endpoint, data) => {
  try {
    const config = {};

    // Check if data is FormData (multipart/form-data)
    if (data instanceof FormData) {
      config.headers = {
        "Content-Type": "multipart/form-data",
      };
    }
    const response = await axiosInstance.post(endpoint, data, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Generic PUT
export const apiPut = async (endpoint, data) => {
  try {
    const config = {};

    // Check if data is FormData (multipart/form-data)
    if (data instanceof FormData) {
      config.headers = {
        "Content-Type": "multipart/form-data",
      };
    }
    const response = await axiosInstance.put(endpoint, data, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Generic DELETE
export const apiDelete = async (endpoint) => {
  try {
    const response = await axiosInstance.delete(endpoint);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
// Generic POST with FormData (for file uploads)
export const apiPostFormData = async (endpoint, formData) => {
  try {
    const response = await axiosInstance.post(endpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Let Axios set the boundary automatically
      },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
